import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { debounce } from "lodash";

import {
  Button,
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
} from "@material-ui/core";

import StructureFields from "components/_refactor/fields/structure";
import ClearButton from "components/_refactor/button/clear";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import PeriodField from "components/_refactor/fields/period-field";
import InputText from "components/_refactor/text/input";
import HeaderClientes from "components/_refactor/headers/clients";
import Snackbar from "components/Alerts/Snackbar";
import LoadingData from "components/Loading/LoadingData";
import TablePedidosPrateleiraInfinita from "./table/TablePedidosPrateleiraInfinita";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import UtilsFncs from "utils/UtilsFncs";
import useLogs from "hooks/logs";
import { IsMobile900, IsMobile } from "utils/is-mobile";

const dataHoje = new Date().toISOString().slice(0, 10);

const statusXMLOption = [
  {
    value: "E",
    name: "Enviados",
    id: 1,
  },
  {
    value: "X",
    name: "Expirados",
    id: 2,
  },
  {
    value: "P",
    name: "Pendentes",
    id: 3,
  },
  {
    value: "T",
    name: "Todos",
    id: 4,
  },
];

function AtendimentosPrateleiraInfinita() {
  const location = useLocation();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const [showCardResultados, setShowCardResultados] = useState(false);
  const [statusXML, setStatusXML] = useState(statusXMLOption[3]);
  const [statusOrderOptions, setStatusOrderOptions] = useState([]);
  const [orderStatus, setOrderStatus] = useState(null);
  const [searchingOrderStatus, setSearchingOrderStatus] = useState(false);
  const [periodo, setPeriodo] = useState(null);
  const [dataInicial, setDataInicial] = useState();
  const [dataFinal, setDataFinal] = useState();
  const [nomeConsumidor, setNomeConsumidor] = useState("");
  const [cpfConsumidor, setCpfConsumidor] = useState("");
  const [nrPedido, setNrPedido] = useState("");
  const [nrAtendimento, setNrAtendimento] = useState("");
  const [sellerList, setSellerList] = useState([]);
  const [seller, setSeller] = useState("");
  const [searchingSeller, setSearchingSeller] = useState(false);

  const [resultados, setResultados] = useState(null);
  const [pesquisando, setPesquisando] = useState(false);

  const [statusPesquisado, setStatusPesquisado] = useState(statusXMLOption[2]);
  const [statusPesquisadoAutoSearch, setStatusPesquisadoAutoSearch] =
    useState("");

  const [openErro, setOpenErro] = useState(false);
  const [msgErro, setMsgErro] = useState("");

  const [openInfo, setOpenInfo] = useState(false);
  const [msgInfo, setMsgInfo] = useState("");

  const [structureFilters, setStructureFilters] = useState(null);
  const [structureLoading, setStructureLoading] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [hasNoGroup, setHasNoGroup] = useState(false);
  const [storeListItens, setStoreListItens] = useState([]);

  const [hideFilters, setHideFilters] = useState(false);
  const [autoSearch, setAutoSearch] = useState(false);

  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;

  const handleCloseErro = useCallback((event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenErro(false);
  }, []);

  const handleCloseInfo = useCallback((event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenInfo(false);
  }, []);

  const handleGetOrderStatusOptions = async () => {
    setSearchingOrderStatus(true);
    await Api.get("order-status", "order", "", true)
      .then((res) => {
        if (res.Success) {
          const statusResult = res.Result;
          const statusList = [];

          statusResult?.map((status) => {
            if (status?.StatusEco) {
              let changeStatusText = status.StatusEco;
              changeStatusText = changeStatusText
                ?.toLowerCase()
                ?.replace(/(?:^|\s)\S/g, function (a) {
                  return a?.toUpperCase();
                });
              const newState = {
                CodigoStatus: status.CodigoStatus,
                Descricao: status.Descricao,
                IndicaVendaLink: status.IndicaVendaLink,
                StatusApp: status.StatusApp,
                StatusEco: changeStatusText,
              };
              statusList.push(newState);
            }
          });
          setStatusOrderOptions(statusList);
        }
      })
      .catch((error) => {
        setLocalStorageApiProblem({
          idMenuAccess: "18",
          screen: "Consulta de Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint order-status - ${error}`,
        });
      })
      .finally(() => setSearchingOrderStatus(false));
  };

  const getAttendanceList = useCallback(
    async ({ idLoja, urlStatus, numeroPedido, page = 1, sizePerPage = 25 }) => {
      setCancelLoading(false);
      setPesquisando(true);

      await Api.get(
        "attendance-b2b-list",
        "attendance",
        "?idLoja=" +
          (idLoja || structureFilters?.idLoja) +
          "&idMarca=" +
          (structureFilters?.idMarca ? structureFilters?.idMarca : "TODAS") +
          "&idCanal=" +
          (structureFilters?.idCanal ? structureFilters?.idCanal : "") +
          "&idRepresentante=" +
          (structureFilters?.idRepresentante
            ? structureFilters?.idRepresentante
            : "") +
          "&idGrupoEconomico=" +
          (structureFilters?.idGrupoEconomico
            ? structureFilters?.idGrupoEconomico
            : "") +
          "&idVendedor=" +
          (seller?.IdLojaVendedor ? seller?.IdLojaVendedor : "") +
          "&status=" +
          (urlStatus ? urlStatus : statusXML?.value) +
          `&dtIni=${dataInicial || ""}&dtFim=${dataFinal || ""}` +
          "&nomeConsumidor=" +
          nomeConsumidor +
          "&cpfConsumidor=" +
          cpfConsumidor +
          "&nrPedido=" +
          (numeroPedido ? numeroPedido : nrPedido) +
          "&nrAtendimento=" +
          nrAtendimento +
          `&page=${page - 1}` +
          `&pageSize=${sizePerPage ? sizePerPage : 25}` +
          `&statusPedido=${
            orderStatus?.StatusEco ? orderStatus?.StatusEco?.toUpperCase() : ""
          }`
      )
        .then((value) => {
          setResultados(value?.Result?.ListPedidos || []);
          setTotalRegisters(value?.Result?.TotalRegistros);
          setCurrentPage(page);
          setCurrentSizePerPage(sizePerPage);
          setShowCardResultados(true);
          if (value?.Result?.ListPedidos) {
            setResultados(value.Result.ListPedidos || []);
          } else {
            setResultados(value.Result || []);
          }
          setPesquisando(false);
        })
        .catch((error) => {
          setMsgErro(
            "Ocorreu um erro ao buscar dados. Verifique os parâmetros informados."
          );
          setOpenErro(true);
          console.log(error);
          setShowCardResultados(false);
          setPesquisando(false);
          setLocalStorageApiProblem({
            idMenuAccess: "18",
            screen: "Pedidos Prateleira Infinita",
            problem: `Erro na chamada do endpoint attendance-b2b-list - ${error}`,
          });
        });
    },
    [
      cpfConsumidor,
      dataFinal,
      dataInicial,
      nomeConsumidor,
      nrAtendimento,
      nrPedido,
      periodo,
      statusXML,
      structureFilters,
      seller,
      orderStatus,
    ]
  );

  const pesquisar = useCallback(async () => {
    setAutoSearch(false);
    setShowCardResultados(false);
    setResultados(null);
    setStatusPesquisado(statusXML);

    await getAttendanceList({
      urlStatus: statusXML?.value ? statusXML?.value : "P",
      page: 1,
      sizePerPage: currentSizePerPage,
    });
  }, [getAttendanceList, statusXML]);

  const triggerAutoSearch = useCallback(
    async (idLoja, status, numeroPedido) => {
      setShowCardResultados(false);
      setResultados(null);
      setPesquisando(true);
      setAutoSearch(true);
      setStatusPesquisadoAutoSearch(status);

      await getAttendanceList({
        numeroPedido,
        idLoja,
        urlStatus: status,
        page: 1,
        sizePerPage: currentSizePerPage,
      });
      setPesquisando(false);
    },
    [getAttendanceList]
  );

  const handleClearFilters = () => {
    setClearFilters(true);
    setPesquisando(true);
    setStructureLoading(true);
    setStatusXML(statusXMLOption[3]);
    setNomeConsumidor("");
    setCpfConsumidor("");
    setNrPedido("");
    setNrAtendimento("");
    setDataInicial(dataHoje);
    setDataFinal(undefined);
    setPeriodo(null);
    setOrderStatus(null);
    setPesquisando(false);
    setStructureLoading(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setPesquisando(false);
    setResultados(null);
  };

  const handleVerifyRequiredInputs = () => {
    if (
      structureFilters?.idGrupoEconomico !== "" ||
      nrPedido ||
      cpfConsumidor ||
      nrAtendimento
    ) {
      setLocalStorageActions({
        nomeTela: "Pedidos Prateleira Infinita",
        idMenu: "18",
        acao: "Clicou para Pesquisar",
      });
      return pesquisar();
    } else {
      if (
        !structureFilters?.idGrupoEconomico &&
        !nrPedido &&
        !cpfConsumidor &&
        !nrAtendimento
      ) {
        setHasNoGroup(true);
      }
    }
  };

  const handleGetSellerList = debounce(async () => {
    setSearchingSeller(true);

    await Api.get(
      "store-saller",
      "commercialstructure",
      "?idPessoaLoja=" +
        structureFilters?.idLoja +
        "&idMarca=" +
        (structureFilters?.idMarca ? structureFilters?.idMarca : "TODAS") +
        "&idCanal=" +
        (structureFilters?.idCanal ? structureFilters?.idCanal : "") +
        "&idRepresentante=" +
        (structureFilters?.idRepresentante
          ? structureFilters?.idRepresentante
          : "") +
        "&idGrupoEconomico=" +
        (structureFilters?.idGrupoEconomico
          ? structureFilters?.idGrupoEconomico
          : ""),
      true
    )
      .then((value) => {
        setSeller("");
        setSellerList(value?.Result?.ListaVendedores);
      })
      .catch((error) => {
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "18",
          screen: "Pedidos Prateleira Infinita",
          problem: `Erro na chamada do endpoint  store-saller - ${error}`,
        });
      })
      .finally(() => {
        setSearchingSeller(false);
      });
  }, 2000);

  useEffect(() => {
    if (location.search) {
      const { Status, idLoja, numeroPedido } = UtilsFncs.GetUrlSearchParams(
        location.search
      );
      const newStatus =
        Status === "Registrado" ? "E" : Status === "Cancelado" ? "X" : "P";
      if (Status && idLoja) {
        setStatusXML(newStatus);
        triggerAutoSearch(parseInt(idLoja, 10), newStatus, numeroPedido);
      }
      if (idLoja && numeroPedido) {
        triggerAutoSearch(idLoja, "T", numeroPedido);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (
      structureFilters?.idGrupoEconomico !== "" ||
      nrPedido ||
      cpfConsumidor ||
      nrAtendimento
    ) {
      setHasNoGroup(false);
    }

    if (
      structureFilters?.idMarca === null &&
      structureFilters?.idCanal === "" &&
      structureFilters?.idRepresentante === "" &&
      structureFilters?.idGrupoEconomico === ""
    ) {
      setClearFilters(false);
    }
  }, [
    structureFilters,
    pesquisando,
    structureLoading,
    statusXML,
    nomeConsumidor,
    cpfConsumidor,
    nrPedido,
    nrAtendimento,
    dataFinal,
    dataInicial,
    periodo,
  ]);

  useEffect(() => {
    if (
      structureFilters !== null &&
      structureFilters?.idGrupoEconomico !== "" &&
      structureFilters?.idGrupoEconomico !== null
    ) {
      handleGetSellerList();
    }
  }, [
    structureFilters?.idGrupoEconomico,
    structureFilters?.idMarca,
    structureFilters?.idLoja,
  ]);

  useEffect(() => {
    setSellerList([]);
    setSeller("");
  }, [structureLoading, structureFilters]);

  useEffect(() => {
    handleGetOrderStatusOptions();
  }, []);

  return (
    <>
      <HeaderClientes
        section="Pedidos Prateleira Infinita"
        subsection="Pedidos"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid container hidden={hideFilters}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <StructureFields
                    fieldsOrder={["economicGroup", "store"]}
                    clearFilters={clearFilters}
                    onStructureFieldsChange={setStructureFilters}
                    disableAll={pesquisando}
                    onStructureFieldsLoad={setStructureLoading}
                    requiredFields={["economicGroup"]}
                    hasNoGroup={hasNoGroup}
                    setStoreList={setStoreListItens}
                    handleSearch={handleVerifyRequiredInputs}
                  />
                  <Grid item xs={12}>
                    <Divider style={{ margin: "0.5rem 0" }} />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Nome Consumidor"
                      value={nomeConsumidor}
                      onChange={(e) => {
                        setNomeConsumidor(e.target.value.slice(0, 100));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="CPF Consumidor"
                      value={cpfConsumidor}
                      onChange={(e) => {
                        setCpfConsumidor(
                          MaskAndValid.maskCPF(e.target.value.slice(0, 14))
                        );
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                      placeholder="000.000.000-00"
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Nº Pedido Prateleira"
                      value={nrPedido}
                      onChange={(e) => {
                        setNrPedido(e.target.value.slice(0, 14));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Nº Atendimento"
                      value={nrAtendimento}
                      onChange={(e) => {
                        setNrAtendimento(e.target.value.slice(0, 14));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={pesquisando}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Vendedor"
                      onChange={(newValue) => {
                        if (newValue !== "all") {
                          setSeller(newValue);
                        } else {
                          setSeller("");
                        }
                      }}
                      loading={structureLoading.length > 0 || searchingSeller}
                      value={seller}
                      options={sellerList}
                      disabled={
                        pesquisando ||
                        searchingSeller ||
                        sellerList?.length === 0
                      }
                      optionIdKey="IdLojaVendedor"
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Status do XML"
                      onChange={(newValue) => {
                        if (newValue !== "all") {
                          setStatusXML(newValue);
                        }
                      }}
                      value={statusXML}
                      options={statusXMLOption}
                      disabled={pesquisando}
                      optionLabelKey="name"
                      optionIdKey="id"
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Status do Pedido"
                      onChange={(newValue) => {
                        if (newValue !== "all") {
                          setOrderStatus(newValue);
                        } else {
                          setOrderStatus(null);
                        }
                      }}
                      loading={
                        structureLoading.length > 0 || searchingOrderStatus
                      }
                      value={orderStatus}
                      options={statusOrderOptions}
                      disabled={pesquisando || searchingOrderStatus}
                      optionLabelKey="StatusEco"
                      optionIdKey="StatusEco"
                    />
                  </Grid>
                  <Grid item xs={periodo?.value === "Outros" ? "12" : "3"}>
                    <PeriodField
                      label="Período"
                      value={periodo}
                      onChange={setPeriodo}
                      initialDate={dataInicial}
                      finalDate={dataFinal}
                      setInitialDate={setDataInicial}
                      setFinalDate={setDataFinal}
                      disabled={pesquisando || statusXML === "P"}
                      required={false}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      onClick={handleVerifyRequiredInputs}
                      disabled={pesquisando}
                    >
                      {pesquisando ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      disable={pesquisando || structureLoading.length > 0}
                      onClick={() => handleClearFilters()}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {!cancelLoading && (
              <>
                <Snackbar
                  text={msgInfo}
                  open={openInfo}
                  autoHideDuration={6000}
                  onClose={handleCloseInfo}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  severity="info"
                  style={{ backgroundColor: "#5e72e4" }}
                />
                <Snackbar
                  text={msgErro}
                  open={openErro}
                  autoHideDuration={6000}
                  onClose={handleCloseErro}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  severity="error"
                />
              </>
            )}
            <LoadingData
              searching={pesquisando}
              onClick={() => handleStopSearching()}
              label="Buscando dados..."
            />
          </Grid>
        </Grid>
        {showCardResultados &&
        resultados &&
        !cancelLoading &&
        !pesquisando &&
        (statusPesquisado || statusPesquisadoAutoSearch) ? (
          <TablePedidosPrateleiraInfinita
            dataTable={resultados}
            totalRegistros={totalRegisters}
            currentPage={currentPage}
            currentSizePerPage={currentSizePerPage}
            search={getAttendanceList}
            hideFilters={setHideFilters}
            statusConsulta={
              autoSearch ? statusPesquisadoAutoSearch : statusPesquisado?.value
            }
          />
        ) : (
          ""
        )}
      </Container>
    </>
  );
}

export default AtendimentosPrateleiraInfinita;
